import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import {LinkContainer} from "react-router-bootstrap";
import {useSelector} from "react-redux";
import {Icons} from "../../../../../../../common/Icons.jsx";


export const Harmonogram = (props) => {
    const form = props.wiz?.form || {};
    const rola = useSelector((state) => state.user.role)
    const id = form.id;
    const status = form.plan_harm_status;
    const isZlozone = status === 'PRZYJĘTY' || status === 'ZŁOŻONY' ;
    const sumaKontrolna = form?.plan_harm_suma_kontrolna;
    const aktualnaSumaKontrolna = form?.aktualna_plan_harm_suma_kontrolna
    const isSumaPoprawna = sumaKontrolna === aktualnaSumaKontrolna;


    return (
        <>
            <JsonViewer src={props.wiz?.form || {}} show={true}/>

            <HeaderTitle noHr size={'fs-3'} title={'Harmonogram prac'}/>


            <div className={'d-flex flex-column gap-3'}>


                <div className={'d-flex gap-3 p-3 mb-1'}>
                    {isZlozone &&(
                        <LinkContainer to={`/${rola}/harm/podglad/${id}`}>
                            <ButtonWithIcon
                                variant={'primary'}
                                size={'sm'}
                                icon={<Icons.eye/>}
                                title={"Podgląd planowanego harmonogramu projektu"}
                                text={"Podgląd planowanego harmonogramu projektu"}
                            />
                        </LinkContainer>
                    )}

                    {!isZlozone && (
                        <LinkContainer to={`/${rola}/harm/edycja/${id}`}>
                            <ButtonWithIcon
                                variant={'primary'}
                                size={'sm'}
                                icon={<Icons.eye/>}
                                title={"Edytuj planowany harmonogram projektu"}
                                text={"Edytuj planowany harmonogramu projektu"}
                            />
                        </LinkContainer>
                    )}

                    {isSumaPoprawna && (
                        // <Badge title={'Aktualna wersja harmonogramu jest zgodna.'} variant={'success'}></Badge>
                        'Aktualna wersja planowanego harmonogramu jest zgodna'
                    )}
                    {!isSumaPoprawna && (
                        //<Badge title={'Aktualna wersja harmonogramu nie jest zgodna.'} variant={'error'}></Badge>
                        'Aktualna wersja planowanego harmonogramu nie jest zgodna'
                    )}

                </div>
            </div>
        </>
    )
}

Harmonogram.propTypes = {
    wiz: PropTypes.any,
}